"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _RateTable = _interopRequireDefault(require("../Pricing/ReviewRates/RateTable"));
var Theme = _interopRequireWildcard(require("../../theme"));
var _Text = _interopRequireDefault(require("../../components/Text"));
var _Button = _interopRequireDefault(require("../../components/Button"));
var _system = require("@mui/system");
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * 
 * @param {*} props 
 * @returns 
 */
var SelectedTile = function SelectedTile(props) {
  var theme = (0, _system.useTheme)();
  var children = props.children,
    selected = props.selected;
  var style = {
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.15)',
    background: '#FFF',
    border: selected && "3px solid ".concat(theme.palette.primary.main),
    width: '254px',
    height: '130px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    margin: '8px',
    position: 'relative',
    '&:hover': {
      boxShadow: !selected && '0px 12px 40px rgba(0, 0, 0, 0.15)'
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    style: style
  }), children);
};
var ClassBlock = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(ClassBlock, _PureComponent);
  function ClassBlock() {
    var _this;
    (0, _classCallCheck2["default"])(this, ClassBlock);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, ClassBlock, [].concat(args)), _this.state = {
      pricing: null,
      showRateTable: false,
      showingRateTableFor: null
    }, _this._showRateTable = function (designID) {
      _this.setState({
        pricing: _this.props.designs[_this.props.classID][designID].pricing,
        showRateTable: true,
        showingRateTableFor: designID
      });
      _this.props.onSelect(_this.props.classID, designID);
    }, _this._hidePricingSummary = function () {
      _this.setState({
        pricing: null,
        showRateTable: false,
        showingRateTableFor: null
      });
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _createClass2["default"])(ClassBlock, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        assignedPlans = _this$props.assignedPlans,
        classID = _this$props.classID,
        designs = _this$props.designs,
        onSelect = _this$props.onSelect,
        whitelabel = _this$props.whitelabel;
      var styles = {
        contentBlock: {
          backgroundColor: Theme.colors.surface,
          boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
          display: 'block',
          margin: 'auto auto 30px auto',
          padding: '30px',
          position: 'relative',
          zIndex: 3
        },
        container: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginBottom: 30
        }
      };
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true,
        bold: true,
        color: whitelabel.primaryColor || Theme.colors.skyBlue
      }, this.props.title), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.container
      }, Object.keys(designs[classID]).map(function (designID, i) {
        return /*#__PURE__*/_react["default"].createElement(SelectedTile, {
          key: i,
          selected: assignedPlans[classID] === designID,
          onClick: function onClick() {
            return onSelect(classID, designID);
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            width: '100%'
          }
        }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          medium: true,
          bold: true,
          display: "block",
          align: "center",
          marginBottom: 20
        }, "".concat(_i18n["default"].t(_tokens["default"].titles.design), " ").concat(i + 1))), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          onClick: function onClick() {
            if (_this2.state.showRateTable && _this2.state.showingRateTableFor === designID) {
              _this2._hidePricingSummary();
            } else {
              _this2._showRateTable(designID);
            }
          },
          transparent: true,
          customStyle: {
            fontSize: 10,
            padding: 0,
            color: whitelabel.primaryColor || Theme.colors.skyBlue
          }
        }, _this2.state.showRateTable && _this2.state.showingRateTableFor === designID ? _i18n["default"].t(_tokens["default"].labels.planDesign.hideSummary) : _i18n["default"].t(_tokens["default"].labels.planDesign.viewSummary)));
      })), this.state.showRateTable && /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.contentBlock
      }, /*#__PURE__*/_react["default"].createElement(_RateTable["default"], {
        pricing: this.state.pricing,
        whitelabel: this.props.whitelabel
      })));
    }
  }]);
  return ClassBlock;
}(_react.PureComponent);
/**
 * @param theme
 * @returns {{customMaxWidth: {maxWidth: string}}}
 */
var _default = exports["default"] = ClassBlock;